var ProUpgrade = function() {

    var _init = function(oken){

        $('#preapproval-check-modal').on('show.bs.modal',function(){
            // var params = new URLSearchParams(window.location.search);
            Do.Ajax('/pro/upgrade/init',{t:oken});
        });

        setTimeout( function(){ 
            ProUpgrade.watch();
        //     $('input#sub-period')
        //         .attr('data-sub', subSelected.length ? subSelected : proSubs.monthly)
        //         .prop('checked',subSelected == proSubs.yearly)
        //         .trigger('change'); 
        }, 500 );

    }

    var _watch = function( content ){
        
        $('#preapp-check-submit').off().on('click',function(){
            Do.Ajax('/pro/upgrade/check',{
                email: $('input[name="check-email"]').val(),
                token: $('input[name="token"]').val()
            });
        });
        
        $('input[name="check-email"]').off().on('focus',function(){
            $('#check-error').empty().addClass('d-none');
        });

        $('#join-waitlist').off().on('show.bs.modal',function(){
            $('input[name="waitlist-email"]').val('');
            $('#waitlist-inputs').addClass('d-block').removeClass('d-none');
            $('#waitlist-close').addClass('d-none').removeClass('d-flex');
            $('#waitlist-setup').addClass('d-block').removeClass('d-none');
            $('#waitlist-confirmed').addClass('d-none').removeClass('d-block');
            $('#waitlist-email-confirm-text').empty();
        });

        $('.waitlist-submit').off().on('click',function(){
            Do.Ajax('/pro/upgrade/waitlist',{
                email: $('input[name="waitlist-email"]').val()
            });
        });

        $('#preapp-verify-submit').off().on('click',function(){
            Do.Ajax('/pro/upgrade/verify',{
                token: $('input[name="token"]').val(),
                code: $('input[name="code"]').val(),
            });
        });

        $('#preapp-finish-submit').off().on('click',function(){
            Do.Ajax('/pro/upgrade/finish',{
                form: $('#preapp-register-form').serializeJSON(),
            });
        });

        $('#preapp-check-problem-back').on('click',function (){
            $('#preapproval-check-content').html(content);
            ProUpgrade.watch();
        });

    }

    var _pwl = function( response ){
        $('#waitlist-inputs').addClass('d-none').removeClass('d-block');
        $('#waitlist-close').addClass('d-flex').removeClass('d-none').on('click',function(){
            $('#join-waitlist').modal('hide');
        });
        $('#waitlist-confirmed').addClass('d-block').removeClass('d-none');
        $('#waitlist-setup').addClass('d-none').removeClass('d-block');
        $('#waitlist-email-confirm-text').html(response.confirmtext);
        ProUpgrade.watch();
    }
        
    return {
        init: function(t) {
            _init(t);
        },
        watch: function( c ){
            _watch( c );
        },
        preapprovalModal: function( r ){
            $('#preapproval-check-content').html(r.html);
            ProUpgrade.watch(r.back);
        },
        checkError: function( r ){
            $('#check-error').text( r.error).removeClass('d-none');
        },
        afterVerify: function( r ){
            $('#preapproval-check-content').html(r.html);
            ProUpgrade.watch();
        },
        paintWatchlist: function(r){
            _pwl(r);
        }
    }

}();

